/**
 * Import React Components
 */
import React, { Component } from 'react';

import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom';

import {
  addInputClasses,
  removeInputClasses
} from 'lib/userInputType';

import asyncComponent from './AsyncComponent';

/**
 * Import Assets
 */
import 'assets/css/normalize.css';
import 'assets/css/global.css';

/**
 * Import Site Header
 */
import Header from 'Components/Header';

/**
 * Import Pages
 */
const Home = asyncComponent(() =>
   import('Pages/Home').then(module => module.default)
);

const Work = asyncComponent(() =>
    import('Pages/Work').then(module => module.default)
);

const WorkList = asyncComponent(() =>
    import('Pages/WorkList').then(module => module.default)
);

const Resume = asyncComponent(() =>
    import('Pages/Resume').then(module => module.default)
);

const Contact = asyncComponent(() =>
    import('Pages/Contact').then(module => module.default)
);

const NoRoute = asyncComponent(() =>
    import('Pages/NoRoute').then(module => module.default)
);

class App extends Component {
  constructor() {
    super();
    this.state = {
      navActive: false,
      headerAlt: false,
      headerSticky: false
    }
   this.handleScroll = this.handleScroll.bind(this);
   this.toggleAltHeader = this.toggleAltHeader.bind(this);
  }

  componentDidMount() {
    /**
     * Add classes based on user input type
     */
    addInputClasses();

    /**
     * Add scroll event to set sticky header class
     */
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    /**
     * Remove classes based on user input type
     */
    removeInputClasses();

    /**
     * Remove scroll event to set sticky header class
     */
    window.removeEventListener('scroll', this.handleScroll);
  }
  /**
   * Handle Scroll
   * @param  {[type]} e [description]
   * @return {[type]}   [description]
   */
  handleScroll() {
    if (window.scrollY === 0 && this.state.isHeaderSticky === true) {
        this.setState({isHeaderSticky: false});
    }
    else if (window.scrollY !== 0 && this.state.isHeaderSticky !== true) {
        this.setState({isHeaderSticky: true});
    }
  }
  /**
   * Toggle Alt Header
   * @param  {[type]} active [description]
   * @return {[type]}        [description]
   */
  toggleAltHeader(active) {
    this.setState({
      headerAlt: active
    });
  }
  render() {
    return (
      <Router onUpdate={this.setWindowTop}>
        <React.Fragment>
          <Header isNavActive={this.state.navActive} isHeaderSticky={this.state.isHeaderSticky} isAltHeader={this.state.headerAlt} />
          <main className="main" id="main">
            <Switch>
              <Route exact path="/" render={(props) => <Home updateHeader={this.toggleAltHeader} />} />
              <Route exact path="/work" component={WorkList}/>
              <Route path ="/work/:id" component={Work} />
              <Route path="/resume" component={Resume}/>
              <Route path="/contact" render={(props) => <Contact updateHeader={this.toggleAltHeader} />} />
              <Route render={(props) => <NoRoute updateHeader={this.toggleAltHeader} />} />
            </Switch>
          </main>
        </React.Fragment>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js